interface IProps {
  lightnessLevel?: string;
  variant?: 'default' | 'custom';
}

export const Divider = ({ lightnessLevel = '100', variant = 'default' }: Readonly<IProps>) => {
  switch (variant) {
    case 'custom':
      return <div className={`w-full border-t-2 border-gray-${lightnessLevel}`} />;
    default:
      return <hr className="bg-KPZ_divider my-1 h-[1px]" />;
  }
};

export default Divider;
